.stack {
  display: inline-flex;
  align-items: center;
  flex-shrink: 0;
  margin: 0;
  padding: 0;
  list-style: none;
}

.item {
  position: relative;
  display: inline-flex;
  border-radius: var(--shape-full);
  box-shadow: 0 0 0 2px var(--md-surface);
}

.sm .item + .item {
  margin-inline-start: -1rem;
}

.md .item + .item {
  margin-inline-start: -1.25rem;
}

.more {
  font: var(--type-label-md);
  letter-spacing: var(--tracking-label-md);
  font-weight: 600;
  align-items: center;
  justify-content: center;
  background: var(--md-surface-container-high);
  color: var(--md-on-surface-variant);
}

.sm .more {
  inline-size: 2rem;
  block-size: 2rem;
}

.md .more {
  inline-size: 2.5rem;
  block-size: 2.5rem;
}
